document.addEventListener("alpine:init", () => {
  Alpine.data("siteNav", () => ({
    open: false,
    toggle() {
      this.open = !this.open;
    }
  }));

  Alpine.data("productPicker", () => ({
    plan: "monthly",
    gallery: 0,
    thumbs: ["Tub", "Facts", "Pump", "Focus", "Energy", "Routine"],
    labels: {
      what: "What is VRSTY Pre?",
      who: "Who's it for?",
      benefits: "Benefits",
      use: "How to use",
      quality: "Formula transparency"
    },
    faqs: {
      what: true,
      who: false,
      benefits: false,
      use: false,
      quality: false
    },
    planDetails: {
      monthly: {
        label: "Monthly Delivery",
        price: "$44.99",
        compare: "",
        sub: "One tub of VRSTY Pre Workout delivered every 30 days."
      },
      quarterly: {
        label: "3-Tub Delivery",
        price: "$134.97",
        compare: "",
        sub: "Three tubs for consistent training blocks."
      },
      once: {
        label: "One-Time Purchase",
        price: "$44.99",
        compare: "",
        sub: "Try one tub without a subscription."
      }
    },
    setPlan(plan) {
      this.plan = plan;
    },
    currentPlan() {
      return this.planDetails[this.plan];
    }
  }));

  Alpine.data("accordionGroup", (firstOpen = 0) => ({
    open: firstOpen,
    toggle(index) {
      this.open = this.open === index ? null : index;
    }
  }));
});

window.addEventListener("DOMContentLoaded", () => {
  if (window.lucide) {
    window.lucide.createIcons();
  }
});

document.addEventListener("change", (event) => {
  const planInput = event.target.closest("input[name='plan-display'][data-variant-id]");
  if (!planInput) return;

  const productArea = planInput.closest("main");
  const productForm = productArea?.querySelector("form.vrsty-product-form");
  const variantInput = productForm?.querySelector("input[name='id']");
  const quantityInput = productForm?.querySelector("input[name='quantity']");
  const sellingPlanInput = productForm?.querySelector("input[name='selling_plan']");

  if (variantInput) {
    variantInput.value = planInput.dataset.variantId;
  }

  if (quantityInput) {
    quantityInput.value = planInput.dataset.quantity || "1";
  }

  if (sellingPlanInput) {
    sellingPlanInput.value = planInput.dataset.sellingPlanId || "";
    sellingPlanInput.disabled = !planInput.dataset.sellingPlanId;
  }
});

const vrstyPendingCartForms = new WeakSet();

function vrstyCartSurface() {
  return document.querySelector("cart-drawer") || document.querySelector("cart-notification");
}

function vrstySetStickyAtcHidden(hidden) {
  document.body?.classList.toggle("vrsty-cart-surface-open", Boolean(hidden));
}

function vrstyObserveCartSurface() {
  const cart = vrstyCartSurface();
  if (!cart) return;

  const syncCartState = () => {
    vrstySetStickyAtcHidden(cart.classList.contains("active"));
  };

  syncCartState();

  const observer = new MutationObserver(syncCartState);
  observer.observe(cart, { attributes: true, attributeFilter: ["class"] });
}

function vrstyResetCartButton(submitButton, label, originalLabel) {
  if (label && originalLabel) {
    label.textContent = originalLabel;
  }

  if (submitButton) {
    submitButton.removeAttribute("aria-busy");
    submitButton.disabled = false;
  }
}

async function vrstyAddFormToCart(form, submitButton) {
  if (vrstyPendingCartForms.has(form)) return;

  vrstyPendingCartForms.add(form);

  const label = submitButton?.querySelector("span");
  const originalLabel = label?.textContent;

  if (submitButton) {
    submitButton.setAttribute("aria-busy", "true");
    submitButton.disabled = true;
  }

  if (label) {
    label.textContent = "Adding...";
  }

  try {
    const formData = new FormData(form);
    if (!formData.get("quantity")) {
      formData.set("quantity", "1");
    }

    const cart = vrstyCartSurface();
    if (cart?.getSectionsToRender) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      cart.setActiveElement?.(document.activeElement);
    }

    const root = window.Shopify?.routes?.root || "/";
    const addUrl = window.routes?.cart_add_url || `${root}cart/add`;
    const response = await fetch(addUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: formData
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || error.message || "Unable to add this product to cart.");
    }

    const parsedState = await response.json();

    if (parsedState.status) {
      throw new Error(parsedState.description || parsedState.message || "Unable to add this product to cart.");
    }

    if (cart?.renderContents && parsedState.sections) {
      vrstySetStickyAtcHidden(true);
      cart.renderContents(parsedState);
      if (cart.classList.contains("is-empty")) {
        cart.classList.remove("is-empty");
      }
      vrstyPendingCartForms.delete(form);
      vrstyResetCartButton(submitButton, label, originalLabel);
      return;
    }

    window.location.href = window.routes?.cart_url || `${root}cart`;
  } catch (error) {
    vrstyPendingCartForms.delete(form);
    vrstyResetCartButton(submitButton, label, originalLabel);

    const message = error instanceof Error ? error.message : "Unable to add this product to cart.";
    window.alert(message);
  }
}

document.addEventListener(
  "click",
  (event) => {
    const button = event.target.closest("form.vrsty-product-form button[type='submit'], button[form]");
    if (!button) return;

    const form = button.form || document.getElementById(button.getAttribute("form"));
    if (!form?.classList?.contains("vrsty-product-form")) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    vrstyAddFormToCart(form, button);
  },
  true
);

window.addEventListener("DOMContentLoaded", vrstyObserveCartSurface);

document.addEventListener(
  "submit",
  async (event) => {
    const form = event.target.closest("form.vrsty-product-form");
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    vrstyAddFormToCart(form, event.submitter || form.querySelector("[type='submit']"));
  },
  true
);
